import { SingletonWebSocket } from './singletonWebSocket.js';
import { SingletonSharedData } from './Singleton/SingletonSharedData.js'
import { IntegrationAPI } from "./IntegrationApi.js";
import { loginService } from './Services/loginService.js';
import { callService } from './Services/callService.js';
import { callBarService } from './Services/callBarService.js';
import { notAvailableService } from './Services/notAvailableService.js';
import { assistedTransferService } from './Services/assistedTransferService.js';
import { chatService } from './Services/chatService.js';
import { callLogService } from './Services/callLogService.js';
import { dispositionCallService } from './Services/dispositionCallService.js';
import { agentDataService } from './Services/agentDataService.js';
import { reprogamCallService } from './Services/reprogamCallService.js';
import { StateRule } from './BusinessRule/StateRule';
import { ongoingCallIvrService } from './Services/ongoingCallIvrService.js';
import { assistedModeService } from './Services/assistedModeService.js';
import { version, name } from '../package.json';
import { auxiliarReadysService } from './Services/auxiliarReadysService.js';

export class IntegrationApiFactory {
	buildClient() {
		const paramsService = { SingletonWebSocket, StateRule, SingletonSharedData }
		const params = {
			"SingletonWebSocket": SingletonWebSocket,
			"SingletonSharedData": SingletonSharedData,
			"loginService": new loginService(paramsService),
			"callService": new callService(paramsService),
			"notAvailableService": new notAvailableService(paramsService),
			"callBarService": new callBarService(paramsService),
			"assistedTransferService": new assistedTransferService(paramsService),
			"chatService": new chatService(paramsService),
			"callLog": new callLogService(paramsService),
			"dispositionCallService": new dispositionCallService(paramsService),
			"agentDataService": new agentDataService(paramsService),
			"reprogamCallService": new reprogamCallService(paramsService),
			"ongoingCallIvrService": new ongoingCallIvrService(paramsService),
			"assistedModeService": new assistedModeService(paramsService),
			"serverIntegrationToken": null,
			"auxiliarReadysService": new auxiliarReadysService(paramsService),
		}
		console.log(name, "Version: ", version);
		return new IntegrationAPI(params);
	}
}


// WEBPACK FOOTER //
// ./src/IntegrationApiFactory.js